import React, { useEffect, useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import { Autocomplete, Box, TextField } from '@mui/material';
import MotionContainer from '../../../../components/FramerMotion/MotionContainer';
import { useDispatch, useSelector } from 'react-redux';
import { getAvailableCourses } from '../../../../redux/features/coursesSlice';
import TermOptionView from './TermOptionView';
import PercentageCoursePymentCheck from './PercentageCoursePymentCheck';
import useResponsive from '../../../../Hooks/useResponsive';
import { getClassroomRange } from '../../../../redux/features/cartSlice';
import { skillxDepartmentNames } from '../../../../utils/constants/departmentDetails';

const CourseOption = () => {
  const departmentName = JSON.parse(localStorage.getItem('cred')).profile?.departmentName;
  const smUp = useResponsive('up', 'sm');

  const mdUp = useResponsive('up', 'md');
  const dispatch = useDispatch();
  const { loading, availableCourse } = useSelector((state) => state.courses);
  const [selected, setSelected] = useState({});

  useEffect(() => {
    const data = {
      skillx: skillxDepartmentNames.includes(departmentName) ? true : false,
    };
    dispatch(getAvailableCourses(data));
    dispatch(getClassroomRange());
  }, []);
  return (
    <GlobalWrapper title={'Course Options'}>
      <Box>
        <Box sx={{ width: smUp ? '40%' : '70%', pb: 2 }}>
          <MotionContainer delay={0.7}>
            <Autocomplete
              disablePortal
              name="Students"
              id="combo-box-demo"
              options={availableCourse || []}
              getOptionLabel={(option) => option.courseName}
              onChange={(e, option, value) => {
                if (option) {
                  setSelected(option);
                }
              }}
              renderInput={(params) => (
                <TextField
                  disabled
                  fullWidth
                  {...params}
                  label="Courses"
                  //   error={formik.touched.subject && Boolean(formik.errors.subject)}
                  //   helperText={formik.errors.subject}
                />
              )}
            />
          </MotionContainer>
        </Box>
      </Box>
      {selected?.courseTypeId == 1 ? (
        <TermOptionView data={selected} />
      ) : selected?.courseTypeId == 2 ? (
        <PercentageCoursePymentCheck />
      ) : null}
    </GlobalWrapper>
  );
};

export default CourseOption;
